import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 180,
  },
  container: {
    display: 'flex',
  },
  paper: {
    margin: theme.spacing(1),
  },
  svg: {
    width: 100,
    height: 100,
  },
  polygon: {
    fill: theme.palette.common.white,
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
}));

export default function HoldBets(props) {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(true);
  const [count, setCount] = useState(10);
  const [message, setMessage] = useState(props.message);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  useEffect(() => {
    setMessage(props.message);
    /*const interval = setInterval(() => {
      console.log('This will run every 15 seconds!');
      timer();
    }, 1000);
    return () => clearTimeout(interval);*/
  });

  const timer = () => {
    if (count > 0) {
      let tempCount = count - 1;
      setCount(tempCount);
    } else {
      //setChecked(false);
      //setMessage([]);
    }
  };

  return (
    <div>
      {console.log('MESSAGE =====>', message)}
      {message &&
        message.map((row) => (
          <div className={classes.root}>
            <div className={classes.container}>
              <Fade in={checked}>
                <Paper
                  style={{
                    backgroundColor: props.color,
                  }}
                  elevation={4}
                  className={classes.paper}
                >
                  {console.log('ROW=====>', row)}
                  {/*row.map(
                    (messageDetail) =>
                      'Player: ' + messageDetail.message.player + ' placed: '
                    row.message.details.length +
                    ' wagers: ' +
                    row.message.details.map(
                      (item) =>
                        item.wagerDescription +
                        ' team: ' +
                        item.teams +
                        ' line: ' +
                        item.line
                    )
                  )*/}
                </Paper>
              </Fade>
            </div>
          </div>
        ))}
    </div>
  );
}
